/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropmessageplaceholder2Inputs */

const en_dropmessageplaceholder2 = /** @type {(inputs: Dropmessageplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message sent as Pulsify…`)
};

const de_dropmessageplaceholder2 = /** @type {(inputs: Dropmessageplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht wird als Pulsify gesendet…`)
};

/**
* | output |
* | --- |
* | "Message sent as Pulsify…" |
*
* @param {Dropmessageplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropmessageplaceholder2 = /** @type {((inputs?: Dropmessageplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropmessageplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropmessageplaceholder2(inputs)
	return de_dropmessageplaceholder2(inputs)
});
export { dropmessageplaceholder2 as "dropMessagePlaceholder" }